import React from 'react'
import Pricing from './Pricing'
import FAQ from './FAQ'
import GetStartedNow from './GetStartedNow'
import Navbar from './Navbar'
import Footer from './Footer'

const Pricingpage = () => {
  return (
    <>
    <Navbar/>
    <Pricing/>
    <FAQ/>
    <GetStartedNow/>
    <Footer/>
    </>
  )
}

export default Pricingpage